module.exports = "<div :class=\"{'weui_loading_toast': type === 'loading'}\">\n  <div class=\"weui_mask_transparent\"></div>\n  <div class=\"weui_toast\">\n    <div class=\"weui_loading\" v-if=\"type === 'loading'\">\n      <div v-for=\"n in 12\" class=\"weui_loading_leaf\" :class=\"'weui_loading_leaf_' + n\"></div>\n    </div>\n    <i class=\"weui_icon_toast\" v-else></i>\n    <div class=\"weui_toast_content\"><slot></slot></div>\n  </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/toast/toast.vue
 ** module id = 102
 ** module chunks = 0
 **/